<script setup>
const props = defineProps({
  metric: {
    type: Object,
    required: true,
  },
})

const gaugeStyle = computed(() => ({
  background: `conic-gradient(from 220deg, #38bdf8 0 ${props.metric.score * 0.75}%, rgba(148, 163, 184, 0.18) ${props.metric.score * 0.75}% 75%, transparent 75% 100%)`,
}))
</script>

<template>
  <VCard class="review-widget energy-widget">
    <VCardText class="pa-5">
      <div class="d-flex align-center justify-space-between gap-4 mb-4">
        <div>
          <div class="text-overline text-info mb-1">{{ $t('dashboard.weeklyReview.energyOverline') }}</div>
          <h2 class="text-h6 font-weight-bold mb-0">{{ $t('dashboard.weeklyReview.energySync') }}</h2>
        </div>
        <VIcon icon="mdi-brain" color="info" size="28" />
      </div>

      <div class="energy-layout">
        <div class="energy-gauge" :style="gaugeStyle">
          <div class="energy-gauge-inner">
            <strong>{{ metric.score }}%</strong>
            <span>Energy Sync</span>
          </div>
        </div>

        <div>
          <p class="text-body-2 text-medium-emphasis mb-3">
            {{ metric.insight }}
          </p>
          <div class="d-flex flex-wrap gap-2">
            <VChip size="small" color="success" variant="tonal">{{ metric.matches }} aligned</VChip>
            <VChip size="small" color="info" variant="tonal">{{ metric.total }} completed</VChip>
            <VChip v-if="metric.failedLowEnergyHighWork" size="small" color="warning" variant="tonal">
              {{ metric.failedLowEnergyHighWork }} biology mismatch
            </VChip>
          </div>
        </div>
      </div>
    </VCardText>
  </VCard>
</template>

<style scoped lang="scss">
.review-widget {
  block-size: 100%;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(var(--v-theme-surface), 0.86), rgba(var(--v-theme-surface), 0.64)),
    rgba(8, 12, 20, 0.72);
  backdrop-filter: blur(14px) saturate(1.1);
}

.energy-layout {
  display: grid;
  grid-template-columns: 150px 1fr;
  align-items: center;
  gap: 22px;
}

.energy-gauge {
  position: relative;
  display: grid;
  inline-size: 146px;
  block-size: 146px;
  place-items: center;
  border-radius: 50%;
  transform: rotate(0deg);

  &::after {
    position: absolute;
    inset-block-end: 0;
    inline-size: 60%;
    block-size: 35%;
    background: rgb(var(--v-theme-surface));
    content: '';
  }
}

.energy-gauge-inner {
  z-index: 1;
  display: grid;
  inline-size: 104px;
  block-size: 104px;
  place-items: center;
  border-radius: 50%;
  background: rgb(var(--v-theme-surface));
  text-align: center;

  strong {
    font-size: 1.7rem;
    line-height: 1;
  }

  span {
    color: rgba(var(--v-theme-on-surface), 0.58);
    font-size: 0.72rem;
  }
}

@media (max-width: 680px) {
  .energy-layout {
    grid-template-columns: 1fr;
  }
}
</style>
